import { e as P } from "../class-map-Di-Oe7s4.js";
import { x as p, c as C } from "../lit-element-8JrrHldg.js";
import { r as b } from "../state-D4BCZ2JK.js";
import { e as O } from "../query-C42EGI_8.js";
import { w as l } from "../watch-ChG-_stu.js";
import { P as x } from "../pwc-element-CZs0VuUW.js";
import { p as n } from "../pwcProperty-CTLG9yrF.js";
var S = Object.defineProperty, $ = Object.getOwnPropertyDescriptor, a = (e, s, i, r) => {
  for (var o = r > 1 ? void 0 : r ? $(s, i) : s, h = e.length - 1, d; h >= 0; h--)
    (d = e[h]) && (o = (r ? d(s, i, o) : d(o)) || o);
  return r && o && S(s, i, o), o;
}, L = (e, s, i) => {
  if (!s.has(e))
    throw TypeError("Cannot " + i);
}, c = (e, s, i) => {
  if (s.has(e))
    throw TypeError("Cannot add the same private member more than once");
  s instanceof WeakSet ? s.add(e) : s.set(e, i);
}, u = (e, s, i) => (L(e, s, "access private method"), i), f, m, v, w, _, g;
const y = "pwc-option";
let t = class extends x {
  constructor() {
    super(...arguments), c(this, f), c(this, v), c(this, _), this.current = !1, this.selected = !1, this.hasHover = !1, this.slotControlled = [], this.hidden = !1;
  }
  connectedCallback() {
    super.connectedCallback(), this.setAttribute("role", "option"), this.setAttribute("aria-selected", "false");
  }
  handleDisabledChange() {
    this.setAttribute("aria-disabled", this.disabled ? "true" : "false");
  }
  handleHiddenChange() {
    this.setAttribute("aria-hidden", this.hidden ? "true" : "false");
  }
  handleSelectedChange() {
    this.setAttribute("aria-selected", this.selected ? "true" : "false");
  }
  handleValueChange() {
    typeof this.value != "string" && (this.value = String(this.value)), this.value.includes(" ") && (console.error(
      "Option values cannot include a space. All spaces have been replaced with underscores.",
      this
    ), this.value = this.value.replace(/ /g, "_"));
  }
  getTextLabel() {
    var e;
    return (((e = this.defaultSlot) == null ? void 0 : e.textContent) ?? "").trim();
  }
  render() {
    return p`
      <div
        class=${P({
      PwcOption: !0,
      "PwcOption--current": this.current,
      "PwcOption--disabled": this.disabled,
      "PwcOption--hidden": this.hidden,
      "PwcOption--selected": this.selected,
      "PwcOption--hover": this.hasHover
    })}
        @mouseenter=${u(this, v, w)}
        @mouseleave=${u(this, _, g)}
      >
        <p-slot class="PwcOption__prefix" name="prefix" .host=${this}></p-slot>
        <p-slot
          class="PwcOption__label"
          .host=${this}
          @p-slotchange=${u(this, f, m)}
        ></p-slot>
        ${this.description ? p`<span class="PwcOption__description"
              >${this.description}</span
            >` : p`<p-slot
              class="PwcOption__suffix"
              name="suffix"
              .host=${this}
            ></p-slot>`}
      </div>
    `;
  }
};
f = /* @__PURE__ */ new WeakSet();
m = function() {
  const e = this.getTextLabel();
  if (typeof this.cachedTextLabel > "u") {
    this.cachedTextLabel = e;
    return;
  }
  e !== this.cachedTextLabel && (this.cachedTextLabel = e, this.emit("p-slotchange", {
    bubbles: !0,
    composed: !1,
    cancelable: !1
  }));
};
v = /* @__PURE__ */ new WeakSet();
w = function() {
  this.hasHover = !0;
};
_ = /* @__PURE__ */ new WeakSet();
g = function() {
  this.hasHover = !1;
};
t.tagName = y;
a([
  O(".PwcOption__label")
], t.prototype, "defaultSlot", 2);
a([
  b()
], t.prototype, "current", 2);
a([
  b()
], t.prototype, "selected", 2);
a([
  b()
], t.prototype, "hasHover", 2);
a([
  n({ reflect: !0, default: "" })
], t.prototype, "value", 2);
a([
  n({ type: String, default: "" })
], t.prototype, "description", 2);
a([
  n({ type: Boolean, reflect: !0, default: !1 })
], t.prototype, "disabled", 2);
a([
  n({ type: Boolean, reflect: !0, default: !1 })
], t.prototype, "hidden", 2);
a([
  l("disabled")
], t.prototype, "handleDisabledChange", 1);
a([
  l("hidden")
], t.prototype, "handleHiddenChange", 1);
a([
  l("selected")
], t.prototype, "handleSelectedChange", 1);
a([
  l("value")
], t.prototype, "handleValueChange", 1);
t = a([
  C(y)
], t);
export {
  t as PwcOption
};
